export function registrationTabs() {
  const $registrationTab = $('.registration-tabs');
  if (!$registrationTab || $registrationTab.length === 0) return;

  $registrationTab.find('.registration-tabs-pane').eq(0).addClass('active');
  $registrationTab.find('.registration-tabs-nav a').eq(0).addClass('active');

  $registrationTab.find('.registration-tabs-nav a').on('click', (e) => {
    e.preventDefault();
    const $t = $(e.currentTarget);
    $registrationTab.find('.active').removeClass('active');
    $t.addClass('active');
    $($t.attr('href')).addClass('active');
  });
}
